// src/components/common/SearchBar.tsx
import React from 'react';
import Icon from './Icon';

interface SearchBarProps {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    placeholder?: string;
}

/** 페이지 본문 내 지원금 필터 검색 */
const SearchBar: React.FC<SearchBarProps> = ({
    searchTerm,
    setSearchTerm,
    placeholder = '지원금 이름이나 키워드를 입력하세요',
}) => (
    <div className="gh-pagesearch">
        <label htmlFor="gh-page-search" className="sr-only">
            지원금 검색
        </label>
        <input
            id="gh-page-search"
            type="search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder={placeholder}
            autoComplete="off"
        />
        <span className="gh-pagesearch__btn" aria-hidden="true">
            <Icon name="search" size={18} strokeWidth={2} />
        </span>
    </div>
);

export default SearchBar;
